import { useGet } from '../../../../api';
import { USER_MANAGEMENT_BASE_URL } from '../consts';
import { EnrollmentEmail, EnrollmentEmails } from '../../types/enrollmentEmail';
import { useMemo } from 'react';

export interface GetEnrollmentEmailsDto {
    tokenId: string;
    defaultTemplate?: EnrollmentEmailsDto;
    customTemplate?: EnrollmentEmailsDto;
}

interface EnrollmentEmailsDto {
    id: number;
    tokenTypeId: number;
    subject: string;
    content: string;
    includeLogo: boolean;
    createdAt: string;
    updatedAt: string;
    isDeleted: boolean;
    isCustomEmail: boolean;
}

const convertEnrollmentEmailDtoToEnrollmentEmail = (dto: EnrollmentEmailsDto): EnrollmentEmail => ({
    id: dto.id,
    tokenTypeId: dto.tokenTypeId,
    subject: dto.subject,
    content: dto.content,
    createdAt: new Date(dto.createdAt),
    updatedAt: new Date(dto.updatedAt),
    isDeleted: dto.isDeleted,
    isCustomEmail: dto.isCustomEmail
});

const convertEnrollmentEmailsDtoToEnrollmentEmails = (dto: GetEnrollmentEmailsDto): EnrollmentEmails => {
    return {
        tokenId: dto.tokenId,
        defaultTemplate: convertEnrollmentEmailDtoToEnrollmentEmail(dto.defaultTemplate!),
        customTemplate: dto.customTemplate ? convertEnrollmentEmailDtoToEnrollmentEmail(dto.customTemplate) : undefined
    };
};

export const useGetEnrollmentEmailsByTokenTypeId = (tokenTypeId?: number) => {
    const { data: emailsDto, ...restValues } = useGet<GetEnrollmentEmailsDto>({
        url: `${USER_MANAGEMENT_BASE_URL}/enrollmentEmails/${tokenTypeId}`,
        enabled: !!tokenTypeId
    });

    const enrollmentEmails = useMemo(
        () => (emailsDto ? convertEnrollmentEmailsDtoToEnrollmentEmails(emailsDto) : undefined),
        [emailsDto]
    );

    return {
        ...restValues,
        enrollmentEmails
    };
};
